import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=45e25fc3&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"
import style0 from "./publish.vue?vue&type=style&index=0&id=45e25fc3&prod&lang=scss&scoped=true"
import style1 from "./publish.vue?vue&type=style&index=1&id=45e25fc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e25fc3",
  null
  
)

export default component.exports